import { useAolStore } from '../../context/AolContext';
import { AolDataItem } from '../../types/ViewModel/AolItem';

export default () => {
    const { voyageFuelPrices } = useAolStore();

    const getVoyageFuelPrice = (aolDataItem: AolDataItem) =>
        aolDataItem?.aolItem ? voyageFuelPrices.find((v) => v.voyageNumber === +aolDataItem.aolItem.voyageNumber) : null;

    return { getVoyageFuelPrice };
};
